import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(theme => ({
  smallText: {
    fontSize: '0.8em',
    color: '#999'
  },
  boldText: {
    fontWeight: 'bold',
  },
}))

const TeamInfo = ({
  resource,
}) => {

  const classes = useStyles()
  return (
    <div>
      {
        resource.links.map((link, i) => {

          const {
            meta: {
              amount,
            },
            resource,
          } = link
          
          const parts = [
            amount + ' x ',
            resource.name,
          ].filter(s => s)

          return (
            <Typography
              key={ i }
              className={ classes.smallText }
            >
              { parts.join(' ') }
            </Typography>
          )
        })
      }
    </div>
  )
}

export default TeamInfo

